export const cdp = {
	tabs: {
		dashboard: "Vue d'ensemble",
		customers: "Liste des clients",
		rfmAnalysis: "Comportement des clients",
		segments: "Segments",
	},
	common: {
		loading: "Chargement...",
	},
	header: {
		title: "Panneau CRM",
		subtitle:
			"Découvrez, suivez et activez votre base de clients, en transformant les données en campagnes et ventes",
	},
	rfm: {
		labels: {
			champions: "Champions",
			loyal: "Fidèles",
			highPotential: "Fort potentiel",
			promising: "Prometteurs",
			recent: "Récents",
			attention: "À surveiller",
			canNotLose: "À ne pas perdre",
			risk: "À risque",
			closeToHibernation: "Sur le point d'hiberner",
			hibernating: "En hibernation",
			lost: "Perdus",
		},
		descriptions: {
			champions: "Ont acheté récemment, viennent souvent et dépensent le plus",
			loyal: "Reviennent souvent et ont acheté récemment",
			highPotential: "Ont acheté récemment avec de bonnes dépenses — presque fidèles",
			promising: "Achat récent avec de bons signaux de fréquence et de dépense",
			recent: "Ont acheté récemment, mais encore peu de visites",
			attention: "Récence moyenne — ont besoin d'un coup de pouce pour revenir",
			canNotLose: "Dépensaient beaucoup, mais n'ont pas acheté depuis longtemps",
			risk: "Ont bien acheté avant, mais se refroidissent depuis un moment",
			closeToHibernation: "Récence et fréquence faibles — presque inactifs",
			hibernating: "Achats anciens, avec une fréquence et des dépenses faibles",
			lost: "Ont peu acheté, peu dépensé et ne sont jamais revenus",
		},
	},
	dashboard: {
		title: "Tableau de bord CDP",
		subtitle:
			"Suivez vos clients, les indicateurs de relation et la segmentation intelligente",
		filters: {
			period: {
				label: "Période",
				options: {
					last7Days: "7 derniers jours",
					last15Days: "15 derniers jours",
					last30Days: "30 derniers jours",
					last60Days: "60 derniers jours",
					last90Days: "90 derniers jours",
				},
			},
			groupBy: {
				label: "Regrouper par",
				options: {
					week: "Semaine",
					month: "Mois",
				},
			},
			establishments: {
				label: "Établissements",
				all: "Tous",
			},
			apply: "Filtrer",
		},
		advanced: {
			top10Title: "Top 10 des clients par valeur",
			noClients: "Aucun client trouvé",
			visitsPerMonth: "visites/mois",
			viewTop100: "Voir les 100 meilleurs clients",
			sectionTitle: "Analyses avancées",
			sectionSubtitle: "Vue détaillée de la valeur des clients",
			rankingTitle: "Top {{count}} des clients par valeur",
			viewMore: "Voir plus",
			viewLess: "Voir moins",
		},
		alerts: {
			title: "Alertes et risques",
			subtitle: "Indicateurs de vigilance pour votre base de clients",
			cards: {
				inactive: {
					title: "Clients inactifs",
					label: "Inactifs depuis plus de 90 jours",
					tooltip: "Considère les 90 derniers jours à partir d'aujourd'hui.",
					ofBase: "de la base",
					anomalyTooltip:
						"Le pourcentage de clients inactifs dépasse 100 % de la base active. Cela peut indiquer une incohérence dans les données — les clients peuvent être comptés dans plusieurs établissements, ou le total de la base peut ne pas inclure tous les clients historiques.",
				},
				balance: {
					title: "Crédits disponibles",
					tooltip:
						"Solde des recharges que les clients ont chargées et n'ont pas encore dépensées (hors recharges remboursées ou expirées). C'est de l'argent immobilisé dans l'établissement — une bonne raison de faire revenir ces clients.",
					clients: "Clients",
					percentOfBase: "% de la base",
					averagePerClient: "Moyenne/client",
				},
				churn: {
					title: "Clients à risque de churn",
				},
			},
		},
		demographics: {
			title: "Analyse démographique",
			subtitle: "Profil démographique de votre base de clients",
			genderTitle: "Répartition par genre",
			ageTitle: "Répartition par tranche d'âge",
			ageMissingBirthDate:
				"⚠ {{percentage}} % des clients n'ont pas de date de naissance renseignée et sont exclus",
			genders: {
				male: "Homme",
				female: "Femme",
				other: "Autre",
				notInformed: "Non renseigné",
			},
		},
		evolution: {
			title: "Évolution temporelle",
			subtitle: "Suivez l'évolution des indicateurs au fil du temps",
			yAxisClients: "Clients",
			referenceAverage: "Moyenne",
			clientsTooltip: "{{value}} clients",
			activeBase: {
				title: "Évolution de la base active",
				subtitle: "Clients uniques par période",
			},
			averageTicket: {
				title: "Évolution du panier moyen",
				subtitle: "Valeur moyenne par visite",
			},
			newVsRecurring: {
				title: "Nouveaux vs récurrents",
				subtitle: "Composition de la base au fil du temps",
				newClients: "Nouveaux",
				recurringClients: "Récurrents",
			},
			activation: {
				title: "Taux d'activation au fil du temps",
				subtitle:
					"Conversion des nouveaux en récurrents · fenêtre glissante de 180 jours · vs même période l'an dernier",
				currentSeries: "Actuel",
				previousSeries: "Année précédente",
			},
		},
		health: {
			title: "Santé de la base",
			subtitle: "Vue d'ensemble des principaux indicateurs clients",
			variationTooltip: "Variation par rapport à la période précédente",
			activeClients: {
				label: "Clients actifs",
				subLabel: "Clients uniques sur la période",
				tooltip:
					"Clients identifiés (n° fiscal/téléphone) ayant au moins une interaction sur la période sélectionnée",
			},
			averageTicket: {
				label: "Panier moyen",
				subLabel: "Valeur moyenne par visite",
			},
			activationRate: {
				label: "Taux d'activation",
				subLabel: "Conversion des nouveaux en récurrents",
				tooltip: "Pourcentage de nouveaux clients revenus pour une deuxième visite",
				variationSuffix: " pts",
			},
			reactivated: {
				label: "Clients réactivés",
				subLabel: "Clients inactifs revenus",
				tooltip:
					"Clients qui étaient inactifs (>30 jours) et sont revenus sur la période",
			},
			interval: {
				label: "Intervalle moyen",
				subLabel: "Jours entre les visites",
				tooltip: "Plus il est court, mieux c'est - indique un engagement plus élevé",
				daysValue: "{{days}} jours",
			},
		},
		rfmSection: {
			sectionTitle: "Analyse des clients",
			sectionSubtitle: "Répartition de la base par classification RFM",
			chartTitle: "Répartition RFM",
			chartSubtitle:
				"Répartition de la base complète · cliquez sur un segment pour voir les détails · triez par les colonnes",
		},
		rfmDistribution: {
			columns: {
				name: "Classification",
				percentage: "% de la base",
				count: "Clients",
				averageTicket: "Panier moyen",
				totalTpv: "TPV",
			},
			rowTitle: "Voir les clients de ce segment",
		},
		segmentsSection: {
			title: "Segments personnalisés",
			emptySubtitle: "Regroupez les clients par comportement et suivez leurs indicateurs",
			emptyTitle: "Aucun segment personnalisé trouvé",
			emptyText:
				"Créez des segments pour regrouper les clients par comportement — par exemple « VIP » ou « Disparus avec solde » — et suivez les chiffres de chaque groupe ici sur le tableau de bord.",
			createButton: "Créer un segment",
			subtitle: "Cliquez sur un segment pour voir les clients",
			columnName: "Nom du segment",
			columnCount: "Clients",
			columnPercentage: "% base",
			columnAverageTicket: "Panier moyen",
			columnActions: "Actions",
			editSegment: "Modifier le segment",
			deleteSegment: "Supprimer le segment",
		},
		mixClients: {
			title: "Mix de clients",
			new: "Nouveaux",
			recurring: "Récurrents",
			reactivated: "Réactivés",
		},
		valueMatrix: {
			loading: "Chargement…",
			noData: "Aucune donnée sur la période.",
			title: "Concentration de clients",
			total: "Total : {{total}} clients",
			yAxisTitle: "panier moyen (R$)",
			xAxisTitle: "moyenne de visites/mois",
			cellTitle: "{{ticket}}  ·  {{frequency}} visites/mois : {{clients}} clients",
		},
	},
	customers: {
		title: "Liste des clients",
		subtitle: "Recherchez et filtrez les clients de votre base",
		globalFilters: {
			placeLabel: "Établissement",
			placePlaceholder: "Tous les établissements",
			searchPlaceholder: "Rechercher...",
			noResults: "Aucun résultat",
			baseLabel: "Base considérée",
			baseOptions: {
				all: "Toute la base",
				last90Days: "90 derniers jours",
				last180Days: "180 derniers jours",
				last365Days: "365 derniers jours",
			},
		},
		relativeTime: {
			today: "aujourd'hui",
			daysAgo_one: "il y a {{count}} jour",
			daysAgo_other: "il y a {{count}} jours",
			monthsAgo_one: "il y a {{count}} mois",
			monthsAgo_other: "il y a {{count}} mois",
			yearsAgo_one: "il y a {{count}} an",
			yearsAgo_other: "il y a {{count}} ans",
		},
		classificationView: {
			label: "Classification du client :",
			all: "Tous les établissements",
			best: "Uniquement la meilleure",
		},
		filters: {
			removePill: "Retirer {{label}}",
			search: {
				label: "Rechercher",
				placeholder: "Rechercher par nom, e-mail, téléphone ou document...",
			},
			listSearch: {
				placeholder: "Rechercher...",
				noResults: "Aucun résultat",
			},
			place: {
				label: "Établissement",
				placeholder: "Tous les établissements",
				selectedCount: "{{count}} sélectionnés",
			},
			rfmClassification: {
				label: "Classification RFM",
				placeholder: "Toutes les classifications",
				selectedCount: "{{count}} sélectionnées",
			},
			clientClassification: {
				label: "Classification RFM multi-établissements",
				tooltip:
					"Lorsqu'un client a visité plusieurs établissements et possède des classifications différentes, ce filtre définit quelle classification est affichée.",
				all: "Afficher toutes les classifications",
				best: "Afficher uniquement la meilleure",
			},
			segments: {
				label: "Segments",
				placeholder: "Tous les segments",
				selectedCount: "{{count}} sélectionnés",
			},
			allowCommunication: {
				label: "Autorise la communication",
				all: "Tous",
				yes: "Oui",
				no: "Non",
			},
			status: {
				label: "Statut",
				placeholder: "Tous les statuts",
				selectedCount: "{{count}} sélectionnés",
			},
			gender: {
				label: "Genre",
				placeholder: "Tous les genres",
				selectedCount: "{{count}} sélectionnés",
				male: "Homme",
				female: "Femme",
				other: "Autre",
			},
			lastInteraction: {
				label: "Dernière interaction",
				placeholder: "Toute date",
				last7Days: "7 derniers jours",
				last30Days: "30 derniers jours",
				last60Days: "60 derniers jours",
				last90Days: "90 derniers jours",
				moreThan90Days: "Plus de 90 jours",
				custom: "Personnalisé",
			},
			activityPeriod: {
				label: "Période d'activité",
				from: "Du",
				to: "Au",
				lastDays: "{{count}} derniers jours",
				shortcutsLabel: "Derniers :",
			},
			balance: {
				label: "Solde disponible",
				onlyWithBalance: "Uniquement avec solde",
				minBalance: "Solde minimum (R$)",
			},
			consumptionMin: {
				label: "Consommation minimale (R$)",
				placeholder: "Ex. : 100",
			},
			avgTicketMin: {
				label: "Panier moyen minimum (R$)",
				placeholder: "Ex. : 50",
			},
			presences: {
				label: "Minimum de visites",
				labelTotal: "Minimum de visites (total)",
				any: "Indifférent",
				option: "{{count}}+ visites",
				placeholder: "Ex. : 3",
			},
			birthday: {
				label: "Période d'anniversaire",
				from: "Du",
				to: "Au",
				shortcutsLabel: "Suggestions :",
				thisMonth: "Ce mois-ci",
				nextMonth: "Mois prochain",
				invalidDate: "Date invalide.",
				dayColumn: "Jour",
				monthColumn: "Mois",
			},
			birthYear: {
				label: "Âge",
				modeAge: "Âge",
				modeYear: "Année",
				yearLabel: "Année de naissance",
				from: "De",
				to: "À",
			},
			rangeError: "« Au » doit être supérieur à « Du ».",
			product: {
				label: "Produit",
				placeholder: "Tous les produits",
				selectedCount: "{{count}} sélectionnés",
			},
			sections: {
				activity: "Activité et consommation",
				demographics: "Démographie",
			},
			advanced: {
				show: "Plus de filtres",
				hide: "Moins de filtres",
				drawerButton: "Filtres",
				drawerTitle: "Filtres de la liste",
				drawerApply: "Voir {{value}} clients",
				sectionDemographics: "Démographie",
				sectionActivity: "Consommation",
				sectionStatus: "Statut",
			},
			actions: {
				apply: "Appliquer les filtres",
				clear: "Effacer les filtres",
			},
			results: "{{value}} clients trouvés",
			searching: "Recherche de clients...",
			segmentMerge: {
				eyebrow: "Segment",
				hint:
					"Les règles de chaque segment remplissent les filtres ci-dessous. Vous pouvez affiner à votre guise.",
				appliedTitle: "Filtres appliqués",
				appliedByOne: "issus de 1 segment",
				appliedByMany: "issus de {{count}} segments",
				editableBadge: "modifiable",
				markerApplied: "Segment appliqué",
				markerCombined: "Segment combiné",
				markerAdjusted: "Segment ajusté",
				appliedFrom: "Ce filtre provient du segment {{segment}}.",
				appliedActivity:
					"Actifs au cours des {{days}} derniers jours — défini par le segment {{segments}}.",
				combinedFrom: "Ce filtre réunit les segments : {{segments}}.",
				combinedWithManual:
					"Réunit les segments {{segments}} ainsi que votre sélection manuelle.",
				conflictMsg:
					"Plusieurs segments définissent ce filtre. Celui du dernier sélectionné prévaut : {{used}} ({{usedValue}}).",
				activityAdjusted:
					"Les segments utilisent des fenêtres différentes. Nous utilisons la plus grande — {{days}} jours.",
			},
		},
		table: {
			columns: {
				name: "Client",
				contact: "Contact",
				cpf: "Document",
				classification: "Classification",
				behavior: "Comportement",
				birthDate: "Anniversaire",
				firstVisit: "1re visite",
				totalPaid: "Total payé",
				averageTicket: "Panier moy.",
				balance: "Solde disponible",
				hasApp: "Application active",
				actions: "Actions",
			},
			visits: "{{count}} visites",
			lastVisit: "Dernière visite",
			classificationPlace: "{{places}}",
			classificationPlaces: "{{places}}",
			uninformed: "Non renseigné",
			appActive: "Oui",
			appInactive: "Non",
			hasAppTitle: "Application active",
			balanceShort: "Solde",
			firstVisitShort: "Première visite",
			lastVisitShort: "Dernière visite",
			noName: "Sans nom",
			ago: "il y a {{days}} jours",
			totalPaid: "Total payé",
			averageTicket: "Panier moyen",
			balance: "Solde",
			viewDetails: "Voir les détails",
			details: "Détails",
			noResults: "Aucun client trouvé",
			noResultsDescription: "Essayez d'ajuster les filtres pour trouver des clients",
		},
		status: {
			active: "Actif",
			attention: "À surveiller",
			risk: "À risque",
			inactive: "Inactif",
		},
		drawer: {
			title: "Détails du client",
			noName: "Sans nom",
			tabs: {
				summary: "Résumé",
				favoriteProducts: "Produits favoris",
				history: "Historique",
				purchases: "Visites",
			},
			summary: {
				personalData: "Données personnelles",
				document: "Document",
				email: "E-mail",
				phone: "Téléphone",
				birthDate: "Date de naissance",
				ageYears: "{{age}} ans",
				gender: "Genre",
				city: "Ville",
				location: "Établissement",
				preferences: "Préférences",
				allowsCommunication: "Autorise la communication",
				communicationDenied: "N'autorise pas la communication",
				appInstalled: "Application installée",
				noApp: "Pas d'application",
				activitySummary: "Résumé d'activité",
				firstVisit: "Première visite",
				lastVisit: "Dernière visite",
				totalVisits: "Total des visites",
				averageFrequency: "Fréquence moyenne",
				visitsPerMonth: "visites/mois",
				customerFor: "Jours en tant que client",
				financial: "Financier",
				totalPaid: "Total payé",
				averageTicket: "Panier moyen",
				availableBalance: "Solde disponible",
				classifications: "Classifications",
				rfmByPlace: "RFM par établissement",
				segments: "Segments",
			},
			products: {
				product: "Produit",
				category: "Catégorie",
				quantity: "Quantité",
				totalValue: "Valeur totale",
				lastPurchase: "Dernier achat",
				top10: "Top 10 des produits",
				sortByQuantity: "Par quantité",
				sortByValue: "Par valeur",
				noProducts: "Aucun produit favori trouvé",
			},
			history: {
				filterByType: "Filtrer par type",
				allTypes: "Tous les types",
				loadMore: "Charger plus",
				noHistory: "Aucun historique trouvé",
				noPlace: "Sans établissement",
				unknownPlace: "Autre établissement",
				interaction: "visite",
				interactions: "visites",
				firstShort: "1re :",
				lastShort: "dernière :",
				items: "articles",
			},
			purchases: {
				product: "Produit",
				category: "Catégorie",
				quantity: "Qté",
				unitPrice: "Prix unit.",
				total: "Total",
				date: "Date",
				noPurchases: "Aucun achat trouvé",
				loadMore: "Charger plus",
				visitTotal: "Total de la visite",
				visitNoItems: "Aucune consommation enregistrée",
				unitSuffix: "u.",
				discount: "Remise",
				noPlace: "Sans établissement",
				unknownPlace: "Autre établissement",
				loadingMore: "Chargement d'autres visites…",
			},
			actions: {
				close: "Fermer",
				addToSegment: "Ajouter à un segment",
				edit: "Modifier",
			},
		},
		genders: {
			male: "Homme",
			female: "Femme",
			other: "Autre",
			unknown: "Non renseigné",
		},
		interactionTypes: {
			presence: "Présence",
			recharge: "Recharge",
			giftbackRescue: "Utilisation Giftback",
			giftbackExpire: "Expiration Giftback",
			giftbackReceive: "Réception Giftback",
			ticketPurchase: "Achat de billet",
			ticketCancel: "Annulation de billet",
			communication: "Communication",
			rfmMigration: "Migration RFM",
		},
		labels: {
			status: {
				active: "Actif",
				attention: "À surveiller",
				risk: "À risque",
				inactive: "Inactif",
			},
			interaction: {
				Event: "Événement",
				TicketOrder: "Commande de billet",
				NpsSurveyAnswer: "Réponse NPS",
				Communication: "Communication",
				SegmentAlteration: "Modification de segment",
			},
		},
	},
	segments: {
		title: "Segments",
		subtitle: "Créez et gérez des segments de clients personnalisés",
		summary: {
			highestRevenue: "Segment au revenu le plus élevé",
			highestTicket: "Segment au panier moyen le plus élevé",
			mostCustomers: "Segment avec le plus de clients",
			leastCustomers: "Segment avec le moins de clients",
		},
		search: {
			placeholder: "Rechercher un segment...",
		},
		actions: {
			create: "Créer une segmentation",
			edit: "Modifier",
			delete: "Supprimer",
			duplicate: "Dupliquer",
		},
		card: {
			createdBy: "Créé par : {{name}}",
			leads: "{{count}} leads",
			metrics: {
				clients: "Clients",
				revenue: "Revenu",
				avgTicket: "Panier moyen",
				baseShare: "% de la base",
			},
			lastSync: "Dernière synchronisation : {{date}}",
			neverSynced: "Jamais synchronisé",
			syncStatus: {
				synced: "Synchronisé",
				outdated: "Obsolète",
				outdatedTooltip:
					"Le segment a été modifié après la dernière synchronisation et doit être retraité.",
				neverTooltip: "Ce segment n'a pas encore été synchronisé.",
			},
		},
		drawer: {
			titleCreate: "Créer un segment",
			titleEdit: "Modifier le segment",
			fields: {
				name: "Nom",
				namePlaceholder: "Nom du segment",
				description: "Description",
				descriptionPlaceholder: "Décrivez l'objectif de ce segment",
				analysisPeriod: "Actifs au cours des N derniers jours",
				analysisPeriodPlaceholder: "Ex. : 30 (vide = indifférent)",
				analysisPeriodShortcuts: "Suggestions :",
			},
			rules: {
				title: "Règles de segmentation",
				demographic: "Démographiques",
				consumption: "Consommation",
				engagement: "Engagement",
				status: "Statut",
				gender: {
					label: "Genre",
					placeholder: "Sélectionnez les genres",
					male: "Homme",
					female: "Femme",
					other: "Autre",
				},
				birthday: {
					label: "Anniversaire (jour/mois)",
					from: "Du",
					to: "Au",
					shortcutsLabel: "Suggestions :",
					thisMonth: "Ce mois-ci",
					nextMonth: "Mois prochain",
					invalidDate: "Date invalide.",
				},
				birthYear: {
					label: "Âge",
					modeAge: "Âge",
					modeYear: "Année",
					yearLabel: "Année de naissance",
					from: "De",
					to: "À",
				},
				rangeError: "« Au » doit être supérieur à « Du ».",
				listSearch: {
					placeholder: "Rechercher...",
					noResults: "Aucun résultat",
				},
				minPresences: {
					label: "Visites minimales",
					placeholder: "Minimum de visites sur la période",
				},
				minTotalPaid: {
					label: "Valeur totale minimale",
					placeholder: "R$ 0,00",
					tooltip:
						"Montant minimum cumulé dépensé par le client sur la période d'analyse définie. Seuls les clients dont la dépense totale est égale ou supérieure à cette valeur seront inclus dans le segment.",
				},
				minAvgTicket: {
					label: "Panier moyen minimum",
					placeholder: "R$ 0,00",
				},
				minRemainingBalance: {
					label: "Solde disponible minimum",
					placeholder: "R$ 0,00",
				},
				rfmClassification: {
					label: "Classification RFM",
					placeholder: "Sélectionnez les classifications",
				},
				allowCommunication: {
					label: "Autorise la communication",
					any: "Indifférent",
					yes: "Oui",
					no: "Non",
				},
			},
			actions: {
				save: "Enregistrer",
				cancel: "Annuler",
				saving: "Enregistrement...",
			},
			validation: {
				nameRequired: "Le nom est obligatoire",
				descriptionRequired: "La description est obligatoire",
				analysisPeriodRequired: "La période d'analyse est obligatoire",
				analysisPeriodMin: "La période doit être supérieure à 0",
			},
		},
		deleteModal: {
			title: "Supprimer le segment",
			message:
				"Êtes-vous sûr de vouloir supprimer le segment « {{name}} » ? Cette action est irréversible.",
			confirm: "Supprimer",
			cancel: "Annuler",
			deleting: "Suppression...",
		},
		empty: {
			title: "Aucun segment trouvé",
			description: "Créez votre premier segment pour commencer à organiser vos clients.",
			searchEmpty: "Aucun segment ne correspond à votre recherche.",
		},
		toast: {
			createSuccess: "Segment créé avec succès",
			updateSuccess: "Segment mis à jour avec succès",
			deleteSuccess: "Segment supprimé avec succès",
		},
	},
	rfmAnalysis: {
		title: "Analyse RFM",
		subtitle:
			"Analyse de la Récence, de la Fréquence et de la Valeur monétaire des clients",
		configButton: "Configurer les paramètres",
		rangesButton: "Grilles de classification",
		countingNote:
			"Comptage par établissement : un client ayant des classifications différentes selon les établissements est compté dans chacun d'eux — la somme des classes peut dépasser le nombre de clients uniques.",
		viewModes: {
			simplified: "Simplifié",
			detailed: "Détaillé",
		},
		filters: {
			establishment: "Établissement",
			allEstablishments: "Tous les établissements",
			period: "Période",
			groupBy: "Regrouper par",
			periods: {
				last7Days: "7 derniers jours",
				last15Days: "15 derniers jours",
				last30Days: "30 derniers jours",
				last60Days: "60 derniers jours",
				last90Days: "90 derniers jours",
			},
			groupByOptions: {
				week: "Par semaine",
				month: "Par mois",
			},
		},
		charts: {
			distributionTitle: "Nombre par statut RFM au fil du temps",
			distributionSubtitle: "Évolution de la répartition des clients",
			donutTitle: "Répartition des clients",
			donutSubtitle: "Segmentation par classification RFM",
			treemapTitle: "Répartition RFM",
			treemapSubtitle: "Cliquez sur un segment pour voir les détails",
			stackedAreaTitle: "Composition de la base au fil du temps",
			stackedAreaSubtitle: "Évolution des segments RFM",
			total: "Total",
			clients: "clients",
			visible: "Visible",
			donutTooltip: "{{value}} clients ({{percentage}} %)",
		},
		table: {
			title: "Détail par classification RFM",
			subtitle: "Indicateurs détaillés de chaque segment",
			columns: {
				classification: "Classification",
				clients: "Clients",
				percentBase: "% base",
				totalTpv: "TPV total",
				percentTpv: "% TPV",
				averageTicket: "Panier moyen",
			},
			total: "Total",
			noData: "Aucune donnée disponible pour la période sélectionnée",
			rowTitle: "Voir les clients de ce segment",
			showInChart: "Cliquez pour afficher dans le graphique",
			hideFromChart: "Cliquez pour masquer du graphique",
		},
		cards: {
			averageTicket: "Panier moyen",
		},
		summaryCards: {
			groupTitle: "Voir les clients de ce groupe",
		},
		groups: {
			fieis: "Excellents clients",
			promissores: "Bons clients",
			emRisco: "Clients en alerte",
			perdidos: "Clients en état critique",
		},
		quintileRanges: {
			title: "Grilles de classification",
			subtitle:
				"Plages de Récence, de Fréquence et de Panier utilisées pour classer les clients de cet établissement (quintiles calculés sur la base active de l'établissement lui-même)",
			placePlaceholder: "Établissement",
			searchPlaceholder: "Rechercher...",
			noResults: "Aucun résultat",
			columnClassification: "Classification",
			columnRecency: "Récence (dernière visite)",
			columnFrequency: "Fréquence (visites)",
			columnTicket: "Panier moyen par visite",
			footnoteMain:
				"Plages recalculées quotidiennement à partir du comportement propre à l'établissement",
			footnoteReference: " (référence : {{date}})",
			footnoteLegend:
				". « — » = plage non atteignable dans cet établissement (peu de variation dans la base).",
			ranges: {
				empty: "—",
				recencyAny: "toute récence",
				recencyUpTo: "jusqu'à {{value}} jours",
				recencyMoreThan: "plus de {{value}} jours",
				recencyExact: "{{value}} jours",
				recencyBetween: "de {{min}} à {{max}} jours",
				frequencyAny: "tout nombre de visites",
				frequencySingle: "1 visite",
				frequencyUpTo: "jusqu'à {{value}} visites",
				frequencyAtLeast: "{{value}}+ visites",
				frequencyExact_one: "{{value}} visite",
				frequencyExact_other: "{{value}} visites",
				frequencyBetween: "de {{min}} à {{max}} visites",
				ticketAny: "tout panier",
				ticketUpTo: "jusqu'à {{value}}",
				ticketAbove: "au-dessus de {{value}}",
				ticketBetween: "de {{lower}} à {{upper}}",
			},
		},
		treemap: {
			clients: "clients",
			ofBase: "de la base",
			averageTicketLabel: "Panier moyen",
			noData: "Aucune donnée sur la période.",
		},
		configModal: {
			title: "Configurer les paramètres RFM",
			warning:
				"La modification des règles RFM recalculera la classification de tous les clients. Cette opération peut prendre quelques minutes.",
			resetButton: "Rétablir par défaut",
			cancelButton: "Annuler",
			saveButton: "Enregistrer la configuration",
			savingButton: "Enregistrement...",
		},
		errors: {
			loadTitle: "Erreur lors du chargement des données",
			loadText: "Impossible de charger les données de l'analyse RFM. Veuillez réessayer.",
			retryButton: "Réessayer",
		},
		empty: {
			title: "Aucune donnée à afficher",
			text:
				"Il n'y a pas assez de données pour générer l'analyse RFM sur la période sélectionnée. Essayez de sélectionner une période plus longue ou attendez davantage d'interactions des clients.",
		},
		toast: {
			saveSuccess: "Configuration RFM enregistrée avec succès",
			saveError: "Erreur lors de l'enregistrement de la configuration RFM",
			resetSuccess: "Configuration RFM rétablie par défaut",
		},
	},
};
